/* eslint-disable camelcase */
import queueUtagCall from 'features/tealium/queueUtagCall';

function viewItem (param) {

	if (param) {

		queueUtagCall(() => {

			const {
				order_currency_code,
				product_sku,
				product_name,
				product_impression_position,
				product_brand,
				product_category,
				product_price,
				product_quantity,
				product_grouping,
				sku_input_type
			} = param;

			const data = {
				event_name: 'view_item',
				order_currency_code,
				product_sku,
				product_name,
				product_impression_position: product_impression_position[0] ? product_impression_position : [ '0' ],
				product_brand,
				product_category,
				item_list_id: [ window.location.pathname ],
				item_list_name: [ window.location.pathname ],
				product_price,
				product_quantity: product_quantity.length > 0 ? product_quantity : [ '1' ],
				product_grouping,
				sku_input_type
			};

			const utagTrackingPromise = new Promise((resolve) => {

				// utag.link() returns true, or undefined if tracking is blocked
				const wasSuccessful = window.utag.link(data, () => resolve());
				if (wasSuccessful) resolve();

				// Tracking is allowed 500ms for successful resolution,
				// then we resolve the promise regardless.
				setTimeout(() => resolve(), 500);

			});

		});

	}

}

export default viewItem;
